import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e80c414"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "offline-container"
}
const _hoisted_2 = { class: "offline-banner-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "You are currently offline.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Some features are unavailable.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatureContainer = _resolveComponent("FeatureContainer")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_FeatureContainer, { class: "offline-banner" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4
            ], undefined, true),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}